<template>
  <a href="#" ref="copyToClipboard" class="copy-link" :class="{'invite-template': inviteTemplateVariant }" @click.prevent="sendTrackEvent" :data-clipboard-text="value" data-testid="copy-link-to-clipboard">
    <span class="label">{{this.label}}</span>
    <span class="hover-message">Copy link to clipboard</span>
    <span class="copy-container"><span>Copy link</span> <img :src="require('@img/icons-clipboard-2.svg')" /></span>
    <img class="copy-icon" :src="require('@img/icons-clipboard.svg')" />

  </a>
</template>

<style scoped lang="scss">
@import "@/packs/colors.scss";

.hover-message {
  display: none;
}

.copy-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px 0;
  border-radius: 4px;
  color: $bright-blue;
  .copy-container{
    display:none;
    text-transform: uppercase;
    font-weight: 500;
  }
  &:hover(:not(.invite-template)) {
    text-decoration: none;
    background-color: $solitude;

    .label { display: none; }
    .hover-message { display: inline-block; }
  }

  img {
    margin-left: 5px;
    vertical-align: baseline;
  }

  &.invite-template{
    display:grid;
    grid-template-columns: 1fr 82px;
    grid-gap:10px;
    padding: 0 0 8px;
    .copy-icon{
      display:none;
    }
    .copy-container{
      display: inline-flex;
      font-size: 12px;
          height: 22px;
    align-items: center;
    }
    .hover-message{
      display:none;
    }
    .label{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size:12px;
    }
    img{
      width:10px;
    }
    &:hover {
      text-decoration:none;
      .copy-container{
        span{
          text-decoration: underline;
        }
      }
    }
  }
}
</style>

<script>
import ClipboardJS from 'clipboard'
import track from '@/src/tracking';

export default {
  mounted() {
    const vm = this;
    if (vm.container) {
      // This is used because ClipboardJS relies on the currently focused element. If loaded from within a
      // bootstrap modal, pass its id. It would be ideal if we could pass a ref or element instead of an
      // id, but not sure if that's a thing.
      vm.clipboard = new ClipboardJS(vm.$refs.copyToClipboard, { container: document.getElementById(vm.container) });
    } else {
      vm.clipboard = new ClipboardJS(vm.$refs.copyToClipboard);
    }

    vm.clipboard.on('success', () => vm.showToast('success'));
    vm.clipboard.on('error', () => vm.showToast('error'));
  },
  props: {
    value: String,
    label: String,
    container: String,
    inviteTemplateVariant: { type: Boolean, required: false, default: false }
  },
  data: function() {
    return {
      clipboard: null,
      toastShown: false
    }
  },
  computed: {
    message: function () {
      return "Copy link";
    },
  },
  methods: {
    showToast: function(type){
      const vm = this;
      if(!vm.toastShown){
        vm.toastShown = true;

        if(type == 'success'){
          vm.$root.toastSuccess("Share link copied to clipboard")
        }else if(type == 'error') {
          vm.$root.toastError("Could not copy share link");
        }

        // toasts dissapear after 3000 ms + fading
        setTimeout(() => vm.toastShown = false, 3500)
      }
    },
    sendTrackEvent: function () {
      const vm = this;
      track('viewer_copy_link_click', { source: "new_copy_viewer", hashid: vm.$root.item.id, viewer: "dropper" });
    },
  }
}
</script>
